import { render, staticRenderFns } from "./BnAvoirDetail.vue?vue&type=template&id=767104a4&"
import script from "./BnAvoirDetail.vue?vue&type=script&lang=js&"
export * from "./BnAvoirDetail.vue?vue&type=script&lang=js&"
import style0 from "./BnAvoirDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports